import React, { useMemo, useState } from 'react';

import { useParams } from 'react-router-dom';
// import { useStore } from '../../../../store';
import { WTitle, CTitle } from '../../components/Widget';
import RiskPerson from '../../../../../../assets/2025/topic1400/risk_person.png';
import PracticeLeftBg from '../../../../../../assets/2025/topic1400/practice_left_bg.png';
import PracticeImg from '../../../../../../assets/2025/topic1400/practice_img.png';
import Quiz from '../../components/Quiz';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import { useUpdateComponentState } from '../../../hooks';

interface ISection4Props {
  settings: any;
}

const Section4: React.FunctionComponent<ISection4Props> = ({ settings }) => {
  const ID = '5';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  // const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[4],
    [settings?.paragraphs]
  );
  const { quiz } = paragraphsSettings;
  const [state, setState] = useState({
    play: 1,
    isPlayed: false,
    quiz: false,
  });
  const [practice, setPractice] = useState({
    play: 1,
    isPlayed: false,
  });
  const updateComponentState = useUpdateComponentState();
  React.useEffect(() => {
    if (state.play >= 4) {
      updateComponentState(p_course, p_topic, ID, '2025-topic1400-section4-1');
    }
    if (practice.play >= 5) {
      updateComponentState(p_course, p_topic, ID, '2025-topic1400-section4-2');
    }
    // if (state.play >= 4 && state.quiz && practice.play >= 5) {
    //   updateParagraphState(p_course, p_topic, ID, 'completed', []);
    // }
  }, [state, practice]);
  const startPractice = (next = 1) => {
    if (practice.isPlayed) {
      return;
    }
    next += 1;
    setPractice({ play: next, isPlayed: true });
    if (next <= 5) {
      setTimeout(() => startPractice(next), 1000);
    }
  };
  const startPlay = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    next += 1;
    setState({ ...state, play: next, isPlayed: true });
    if (next <= 4) {
      setTimeout(() => startPlay(next), 1000);
    }
  };
  return (
    <div className="topic-section-5">
      <WTitle title={paragraphsSettings?.title} />
      <CTitle title={paragraphsSettings?.subtitle} />
      <div className="risk">
        <div className="risk-description">
          <span
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.description,
            }}
          />
          <img className="risk-person" src={RiskPerson} alt="" />
        </div>
        <img
          className={`arrow-point ${state.play > 1 ? 'hide' : ''}`}
          src={ImgPoint}
          alt=""
        />
        <div
          id="2025-topic1400-section4-1"
          className="risk-list"
          onClick={() => startPlay()}
        >
          {paragraphsSettings?.list?.map(
            (item: { title: string; content: string }, i: number) => (
              <div
                key={i}
                className={`risk-list-item ${
                  state.play > i + 1 ? 'fade-in' : ''
                }`}
              >
                <div className="item-title">{item.title}</div>
                <div className="item-content">{item.content}</div>
              </div>
            )
          )}
        </div>
      </div>
      <div className="practice">
        <div className="practice-top">
          <div className="top-title">{paragraphsSettings?.practiceTitle}</div>
          <div className="top-line1" />
          <div className="top-line2" />
          <div
            className="top-line3"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.practiceDescription,
            }}
          />
          <img className="practice-top-img" src={PracticeLeftBg} alt="" />
        </div>
        <div id="2025-topic1400-section4-2" className="practice-bottom">
          <img
            src={PracticeImg}
            alt=""
            className="practice-bottom-img pc_show"
          />
          <img
            className={`arrow-point ${practice.play > 1 ? 'hide' : ''}`}
            src={ImgPoint}
            alt=""
          />
          <div className="practice-bottom-list" onClick={() => startPractice()}>
            {paragraphsSettings?.arr?.map((item: any, i: number) => (
              <div
                key={i}
                className={`list-item ${
                  practice.play > i + 1 ? 'fade-in' : ''
                }`}
              >
                <div className="list-item-title">{`0${i + 1}`}</div>
                <span> {item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div id="2025-topic1400-section4-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              '2025-topic1400-section4-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section4;
